module.exports = __webpack_public_path__ + "8287a44425cc9877190936d448c71857.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/wechat.png
// module id = 635
// module chunks = 47